module.exports = __webpack_public_path__ + "img/icon_setting.256cf88e.png";